"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardShop = CardShop;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const sessionContext_1 = require("~/game/sessionContext");
const networking_1 = require("~/networking");
const players_1 = require("~/store/game/players");
const cardShop_1 = require("./presentation/cardShop");
function CardShop() {
    var _a, _b;
    const gameActions = (0, networking_1.useGameActions)();
    const cards = (0, react_redux_1.useSelector)((state) => state.game.cardShop.cards);
    const localPlayer = (0, players_1.useLocalPlayer)();
    const money = (_a = localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.money) !== null && _a !== void 0 ? _a : 0;
    const canUseShop = ((_b = localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.health) !== null && _b !== void 0 ? _b : 0) > 0;
    const shopLocked = (0, react_redux_1.useSelector)((state) => state.game.cardShop.locked);
    const isSpectating = (0, react_redux_1.useSelector)((state) => state.game.spectating.id !== null);
    const { board, bench, pieceRegistry } = (0, sessionContext_1.useGameSession)();
    const ownedDefinitionIds = React.useMemo(() => [
        ...board
            .getAllPieces()
            .map((piece) => pieceRegistry.getPieceById(piece.id).definitionId),
        ...bench
            .getAllPieces()
            .map((piece) => pieceRegistry.getPieceById(piece.id).definitionId),
    ], [board, bench, pieceRegistry]);
    const onBuy = React.useCallback((index) => gameActions.buyCard(index), [gameActions]);
    if (cards === null || canUseShop === false || isSpectating) {
        return null;
    }
    return (React.createElement(cardShop_1.CardShopPresentation, { cards: cards, ownedDefinitionIds: ownedDefinitionIds, money: money, isLocked: shopLocked, onToggleLock: gameActions.toggleShopLock, onReroll: gameActions.rerollCards, onBuy: onBuy }));
}
